import CheckIcon from 'assets/icons/check.svg';
import MailIcon from 'assets/icons/subscribe.svg';
import InfoIcon from 'assets/icons/help.svg';
import MailImage from 'assets/images/mail.png';
import TextField from 'components/TextField';
import { sendEmail } from 'network/sendEmail';
import { ChangeEvent, useState } from 'react';
import isEmail from 'validator/es/lib/isEmail';
import './checkbox.css';

const SubscribeSection = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subscribe, setSubscribe] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [subscribedError, setSubscribedError] = useState(false);
  // const [checked, setChecked] = useState(false);

  // const onCheckboxClick = () => {
  //   setChecked(prev => !prev);
  // };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSubscribe(event.target.value);
  };

  const onSubscribe = async () => {
    setIsSubmitting(true);
    await sendEmail(subscribe)
      .then(res => {
        setIsSubmitting(false);
        setSubscribed(true);
      })
      .catch(error => {
        console.error(error);
        setIsSubmitting(false);
        setSubscribedError(true);
      });
  };

  return (
    <div className='w-full bg-green-100 dark:bg-gray-900 flex flex-col items-center py-14 px-2 gap-4 rounded-2xl'>
      <div className='flex flex-col items-center gap-4'>
        <img src={MailImage} alt='' />
        <p className='text-3xl font-light max-w-[520px] text-center'>
          {subscribed
            ? 'Successfully subscribed!'
            : 'Subscribe for updates to this tool and the latest insights from ICONIQ'}
        </p>
        {subscribedError ? (
          <p className='text-red-400'>
            Sorry, we ran into a problem and are looking into the issue.
            <br />
            Please try to subscribe again later.
          </p>
        ) : (
          ''
        )}
      </div>
      <div className='flex flex-col items-center w-full'>
        <TextField
          id='subscribe_button'
          name='subscribe'
          value={subscribe}
          onChange={onChange}
          icon={MailIcon}
          buttonLabel={
            subscribed ? '' : isSubmitting ? 'Subscribing...' : 'Subscribe'
          }
          buttonIcon={CheckIcon}
          onClick={onSubscribe}
          placeholder='Email Address'
          // disabled={!isEmail(subscribe) || !checked}
          disabled={!isEmail(subscribe) || isSubmitting}
          readOnly={subscribed}
          tooltip={{
            id: 'add_tooltip',
            content: 'Please enter your email address to submit this form.',
            icon: InfoIcon
          }}
          className='w-[460px] !border-gray-500 !dark:border-gray-500'
          inputClassName={`${subscribe ? 'w-full' : 'w-[105px]'}`}
        />
        {!!subscribe && !isEmail(subscribe) && (
          <p className='text-xs font-light'>
            Please enter a valid email address
          </p>
        )}
      </div>
      {/*
        {!subscribed && (
          <input
            name='00NRN000000XzJG'
            className='checkbox !accent-gray-200 !mr-0 text-lg font-light text-left'
            type='checkbox'
            onChange={onCheckboxClick}
            checked={checked}
          />
        )}
      */}
      <p className='w-[712px] text-gray-700 dark:text-gray-500 text-[14px] font-light leading-[19.2px]'>
        By opting in, you agree to receive marketing communications from ICONIQ
        Capital, LLC or its affiliates. You can unsubscribe at any time by
        following the instructions provided in the communication. For more
        information, please see our{' '}
        <a
          href='https://www.iconiq.com/privacy/privacy-policies'
          target='_blank'
          rel='noopener noreferrer'
          className='text-[14px] font-light cursor-pointer leading-[16px] border-0 underline'
        >
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default SubscribeSection;
